/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = [".mat-checkbox-checked .mat-checkbox-background{background-color:#75ba1d!important}  .mat-checkbox-ripple .mat-ripple-element{background-color:rgba(117,186,29,.26)!important}.mat-radio-outer-circle[_ngcontent-%COMP%],   .mat-radio-button.mat-accent.mat-radio-checked .mat-radio-outer-circle{border-color:#75ba1d!important}  .mat-radio-button.mat-accent .mat-radio-inner-circle{background-color:#75ba1d!important}"];
export { styles as styles };
